import "../../pages/ContentFrame.css";

const VideoLayoutCard = (props) => {
    return (
        <div>
            <div className="w-full flex justify-center items-center">
                <div className="certificate_grid_container">{props.cardList}</div>
            </div>
        </div>
    );
};
export default VideoLayoutCard;
